module.exports = __webpack_public_path__ + "static/media/aceshades-3.cf93100c.png";